import React, { useCallback, useEffect, useMemo, useState } from "react";
import { connect, useSelector } from "react-redux";
import {
  isAgencyApproved,
  isSuperAgent,
  token,
  userAgencyObject,
} from "../../modules/auth";
import { fetchIndustries } from "../../modules/industries";
import {
  companyUnload,
  fetchBookingDesks,
  fetchSelectedAgencies,
  unloadCompanyUser,
} from "../../redux/actions";
import { change, getFormValues, reduxForm } from "redux-form";
import EnquiryTypeToggle from "./EnquiryTypeToggle";
import CompanyClientSelector from "./CompanyClientSelector";
import { form } from "./Rfp";
import { isAgencyAdmin, isAgencyUser } from "../../modules/permissions";
import { USER_TYPES } from "../../constants";

let allowedAgencySpecificUserTypes = [
  USER_TYPES.CORPORATE,
  USER_TYPES.AGENCY,
  USER_TYPES.VENUE,
];

const ClientFieldsSection = ({
  token,
  change,
  editEnquiry,
  isSuperAgent,
  fetchSelectedAgencies,
  userAgency,
  isAgencyUser,
  isAgencyAdmin,
  isAgencyApproved,
  companyUser,
  unloadCompanyUser,
  companyFromEnquiry,
  companyUnload,
  template,
}) => {
  const agencyCanView = useMemo(
    () => (isAgencyUser || isAgencyAdmin) && isAgencyApproved,
    [isAgencyUser, isAgencyAdmin, isAgencyApproved]
  );
  const [enquiryType, setEnquiryType] = useState();
  const [agencyCode, setAgencyCode] = useState(null);
  const values = useSelector(getFormValues("rfp_enquiry"));
  const [client, setClient] = useState(values?.client);
  useEffect(() => {
    if (isSuperAgent) {
      fetchSelectedAgencies(token, !editEnquiry);
    }
  }, []);

  useEffect(() => {
    if (template) {
      setAgencyCode(template.enquiry.agency_id);
      change(form, "super_agency_code", template.enquiry.agency_id);
      if (template?.enquiry?.client) {
        change(form, "client_id", template.enquiry.client.id);
      }
      change(form, "company_id", template.enquiry.client_company.id);
    }
  }, [template]);

  useEffect(() => {
    if (!editEnquiry && companyUser) {
      setClient(companyUser);
      addClient(companyUser);
    }
    if (Object.entries(companyFromEnquiry).length === 0 && companyUser) {
      setClient(values?.client);
    }
  }, [companyUser]);

  useEffect(() => {
    companyUnload();
    if (enquiryType) {
      setAgencyCode(enquiryType.code);
      change(form, "super_agency_code", enquiryType.code);
    }
    if (!editEnquiry && !template) {
      setClient(null);
      unloadCompanyUser();
      change(form, "client_id", null);
      change(form, "company_id", null);
    }
  }, [enquiryType]);

  useEffect(() => {
    if (
      values &&
      values?.super_agency_code === null &&
      userAgency &&
      !editEnquiry
    ) {
      change(form, "super_agency_code", userAgency.id);
      setAgencyCode(userAgency.id);
    }
    if (values?.super_agency_code) {
      setAgencyCode(values.super_agency_code);
    }
  }, [values?.super_agency_code, userAgency]);

  const addClient = useCallback(client => {
    if (client) {
      change(form, "client_id", client.id);
      setClient(client);
    }
  }, []);

  const removeClient = useCallback(() => {
    change(form, "client_id", null);
    setClient(null);
  }, []);

  if (
    agencyCanView &&
    ((editEnquiry &&
      (client === null ||
        (client &&
          allowedAgencySpecificUserTypes.includes(client.user_type_id)))) ||
      !editEnquiry)
  ) {
    return (
      <div className={"p-4 mb-4 border border-grey-md"}>
        <p className={"mb-1 block font-normal font-heading text-sm uppercase"}>
          Client details
        </p>
        {!editEnquiry && (
          <EnquiryTypeToggle
            form={form}
            enquiryType={enquiryType}
            setEnquiryType={setEnquiryType}
            agencyFromTemplate={template?.enquiry?.client_company?.agency_id}
          />
        )}
        <CompanyClientSelector
          form={form}
          editEnquiry={editEnquiry}
          agencyCode={agencyCode}
          addClient={addClient}
          client={client}
          setClient={setClient}
          setAgencyCode={setAgencyCode}
          template={template}
          companyFromEnquiry={template ? template.enquiry.client_company : null}
        />
      </div>
    );
  }
  return null;
};

const mapStateToProps = state => {
  return {
    ...state.selectedAgencies,
    ...state.agencyBookingDesks,
    ...(state.companyUser || null),
    companyFromEnquiry: state.company?.company || null,
    userAgency: userAgencyObject(state),
    isSuperAgent: isSuperAgent(state),
    token: token(state),
    isAgencyUser: isAgencyUser(state.auth),
    isAgencyAdmin: isAgencyAdmin(state.auth),
    isAgencyApproved: isAgencyApproved(state),
  };
};

const mapDispatchToProps = {
  fetchIndustries,
  fetchBookingDesks,
  fetchSelectedAgencies,
  change,
  unloadCompanyUser,
  companyUnload,
};
export default reduxForm({
  destroyOnUnmount: false,
  forceUnregisterOnUnmount: true,
})(connect(mapStateToProps, mapDispatchToProps)(ClientFieldsSection));
